import { FormControl, MenuItem, Select } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "../AppContext";

const PosProfilePicker = () => {
    const { posProfile, posProfiles, setPosProfile } = useContext(AppContext);
    const availableProfiles = posProfiles || [];

    if (availableProfiles.length <= 1) {
        return null;
    }

    return (
        <FormControl variant="outlined" size="small">
            <Select
                sx={{
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    "& .MuiSelect-icon": {
                        color: "primary.contrastText",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "primary.main",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "primary.dark",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "primary.dark",
                    },
                }}
                value={posProfile?.name || ""}
                onChange={(e) => setPosProfile(e.target.value, true)}
                displayEmpty
            >
                {availableProfiles.map((profile) => (
                    <MenuItem key={profile.name} value={profile.name}>
                        {`${profile.name}`}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default PosProfilePicker;
